const streamConfig = {
  audio: true,
  video: {
    width:480,
    height:360
  },
  frameRate: { min: 13, ideal: 13, max: 13 }
};

export default streamConfig;